import MuiAlert, { AlertColor } from '@mui/material/Alert';
import React from 'react';

interface AlertProps {
    type: 'success' | 'error' | 'warning';
    children: React.ReactNode;
}

export const Alert = (props: AlertProps) => {
    return (
        <MuiAlert severity={props.type as AlertColor} sx={{ fontFamily: 'var(--hps-primary-font)', marginBottom: '5px' }}>
            {props.children}
        </MuiAlert>
    );
};
